import { compose } from 'redux';
import { connect } from 'react-redux';
import withLayoutContext from '~/components/LayoutContextProvider';
import { setModalType, registerModal } from '~/components/Modals';
import RootStoreContext from '~/contexts/RootStoreContext';
import {
  actions as clientApplicationsActions,
  selectors as clientApplicationsSelectors
} from '~/domains/clientApplications';
import { actions as modalActions } from '~/domains/modal';
import ResetClientSecretConfirmModal from './ResetClientSecretConfirmModal';

const mapStateToProps = (state) => ({
  isLoading: clientApplicationsSelectors.isResetingClientSecret(state)
});

const mapDispatchToProps = (dispatch) => ({
  onCancel: (params) => dispatch(modalActions.closeModal(params)),
  onConfirm: (application) =>
    dispatch(clientApplicationsActions.resetClientSecret(application))
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onConfirm: () => dispatchProps.onConfirm(ownProps.application)
});

export default compose(
  registerModal,
  setModalType('ResetClientSecretConfirmModal'),
  withLayoutContext(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps, {
    context: RootStoreContext
  })
)(ResetClientSecretConfirmModal);
